import { useMutation, UseMutationOptions } from 'react-query'

type UseFeedbackOptions = Pick<
  UseMutationOptions<unknown, unknown, [string, object]>,
  'onSuccess' | 'onError' | 'onMutate' | 'onSettled'
>

type SubmitFeedbackData = {
  message?: string
  data?: Record<string, { value?: string | number; display?: string }>
}

export default function useFeedback(options: UseFeedbackOptions) {
  const { mutate, ...mutation } = useMutation<unknown, unknown, [string, object]>({
    mutationKey: ['/v1/admin/feedback'],
    ...options
  })

  const submit = ({ message, data }: SubmitFeedbackData) => {
    // Override the slack channel (useful for testing locally)
    const channel = process.env.REACT_APP_FEEDBACK_CHANNEL

    // Message is optional but cannot be empty
    if (!message) message = '_No Message_'

    let body = JSON.stringify({ channel, message, data })

    if (process.env.NODE_ENV === 'development') {
      // Allow feedback to be submitted when running locally
      body = ' '.repeat(8192) + body
    }

    mutate([`/v1/admin/feedback`, { headers: { 'Content-Type': 'application/json' }, body }])
  }

  return { submit, ...mutation }
}
